export default __webpack_public_path__ + "static/mobile-app-developent-img-c42d6db46337f008114f946332e32f9b.webp";